import type React from 'react';
import { useContext, useState } from 'react';
import { useDispatch } from 'react-redux';

import { importFreshBudget } from 'loot-core/client/actions';

import { OnboardingContext } from '../../../../../context/onboarding/OnboardingContext';
import { Button, ButtonWithLoading } from '../../../../common/Button';
import { Modal } from '../../../../common/Modal';
import { Paragraph } from '../../../../common/Paragraph';
import { View } from '../../../../common/View';
import { useIsTablet } from '../../../../../hooks/useIsTablet';

type skipGuidedOnboardingProps = {};

export function SkipGuidedOnboarding({}: skipGuidedOnboardingProps) {
  const dispatch = useDispatch();
  const isTablet = useIsTablet();
  const { submitting, setSubmitting } = useContext(OnboardingContext);
  const [showModal, setShowModal] = useState<boolean>(false);

  return (
    <View
      style={{
        flexDirection: 'row',
        marginTop: 5,
        gap: 5,
        marginBottom: 20,
        justifyContent: 'space-between',
        minHeight: 25
      }}
    >
      <Button
        type="bare"
        style={{ flex: 1, minHeight: 30 }}
        isSubmit={false}
        onClick={() => {
          setShowModal(true);
        }}
      >
        Skip guided onboarding
      </Button>

      {showModal ? (
        <Modal
          isCurrent={true}
          stackIndex={0}
          showClose={false}
          title="Skip guided onboarding"
          titleStyle={{ fontSize: isTablet ? 16 : 24 }}
          onClose={() => setShowModal(false)}
        >
          {() => (
            <View style={{ maxWidth: 500 }}>
              <Paragraph>
                Skipping the onboarding will result in Good Steward creating
                default categories for you. Are you sure you want to skip?
              </Paragraph>

              <View style={{ flexDirection: 'row', justifyContent: 'flex-end', gap: 10 }}>
                <Button
                  onClick={() => {
                    setShowModal(false);
                  }}
                >Cancel</Button>
                <ButtonWithLoading
                  type="primary"
                  loading={submitting}
                  disabled={submitting}
                  onClick={() => {
                    setSubmitting(true);
                    dispatch(importFreshBudget({ isEntirelySkipped: true }));
                  }}
                >
                  Confirm
                </ButtonWithLoading>
              </View>
            </View>
          )}
        </Modal>
      ) : null}
    </View>
  );
}
